//
import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'motion/react';
const LogoElement = ({ items, startIndex, delay, cycleLength, transition, columnCount }) => {
    const [currentIndex, setCurrentIndex] = useState(startIndex);
    const [isFirstRender, setIsFirstRender] = useState(true);
    useEffect(() => {
        if (isFirstRender) {
            setIsFirstRender(false);
            return;
        }
        const showNextTimer = setTimeout(() => {
            setCurrentIndex((prevIndex) => (prevIndex + columnCount) % items.length);
        }, cycleLength);
        return () => {
            clearTimeout(showNextTimer);
        };
    }, [currentIndex, items.length, isFirstRender]);
    return (React.createElement("div", { className: "flex-1 relative h-10 w-full flex items-center justify-center" },
        React.createElement(AnimatePresence, null,
            React.createElement(motion.img, { key: currentIndex, src: items[currentIndex]?.url, alt: items[currentIndex]?.altText, initial: { opacity: isFirstRender ? 1 : 0, filter: isFirstRender ? 'blur(0px)' : 'blur(10px)' }, animate: { opacity: 1, filter: 'blur(0px)' }, exit: { opacity: 0, filter: 'blur(10px)' }, transition: { duration: transition, ease: 'easeInOut', delay }, className: "absolute max-w-full object-contain max-h-full" }))));
};
export default LogoElement;
